export {
    default as transformElementForDarkMode,
    AlteredElement,
} from './utils/transformElementForDarkMode';
